import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../../../../../components/Spinner';
import { itemSearch } from '../../../../../../../../redux/modules/items';
import { useCompanyCodes, useCompanyItemTypesData } from '../../../../../../../../services/company-service';
import InsuredSectionDropdown from '../InsuredSectionDropdown';

import ItemTable from './components/ItemTable';
import ItemIconTray from './components/ItemTable/components/ItemIconTray';

const Items = ({ companyId, recordId, insuredId, jobId }) => {
  const { data: itemTypes, isLoading: itemTypesLoading } = useCompanyItemTypesData(companyId);
  const { data: companyCodes } = useCompanyCodes(companyId);

  const itemsPageInfo = useSelector(itemSearch.selectPageInfo);

  const title = useMemo(() => {
    if (itemTypesLoading) {
      return 'loading... ';
    }

    return `${itemTypes[0]?.displayName || 'N/A'} 
         (${(typeof itemsPageInfo.total !== 'undefined'
      && itemsPageInfo.total !== null) ? itemsPageInfo.total : 'loading... '})`;
  }, [itemTypesLoading, itemsPageInfo]);

  if (itemTypesLoading) {
    return (
      <InsuredSectionDropdown
        openByDefault
        icons={<ItemIconTray />}
        title={title}
      >
        <Box height="200px">
          <LoadingSpinner isInline minHeight="200px" />
        </Box>
      </InsuredSectionDropdown>
    );
  }

  return (
    <InsuredSectionDropdown
      openByDefault
      icons={<ItemIconTray />}
      title={title}
    >
      <ItemTable companyId={companyId} insuredId={insuredId} jobId={jobId} />
    </InsuredSectionDropdown>
  );
};

Items.propTypes = {
  companyId: PropTypes.number.isRequired,
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired
};

export default Items;
